import { deleteInReducer, getdropdownvalue } from "@project/components/utilityFunctions"
import { convertIntif } from "@project/sharedcomponents/utilityFunctions"
import {
  CUSTOM_FIELD_LOCAL_SEARCH,
  CUSTOM_FIELD_SERVICE_CLEAR,
  CUSTOM_FIELD_SERVICE_DELETED,
  CUSTOM_FIELD_SERVICE_FAIL,
  CUSTOM_FIELD_SERVICE_INSERTED,
  CUSTOM_FIELD_SERVICE_START,
  CUSTOM_FIELD_SERVICE_SUCCESS,
  CUSTOM_FIELD_SERVICE_UPDATED,
} from "../Actions/types"
const INITIAL_STATE = {
  error: "",
  loading: false,
  data: [],
  totalcount: 0,
  rowsPerPage: 0,
  page: 0,
  order: "asc",
  orderBy: "name",
  norecord: false,
  search_text: "",
  deleted: false,
  columnData: [
    { id: "labelName", numeric: false, visible: true, label: "Label Name" },
    { id: "dataType", numeric: false, visible: true, label: "Data Type", width: 200 },
  ],
  metadata: "",
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOM_FIELD_SERVICE_START:
      return { ...state, loading: true, error: "" }
    case CUSTOM_FIELD_SERVICE_SUCCESS:
      let updatedcoloumn = action.payload.data.result.map((item, index) => {
        const updateditem = { ...item }
        var filter_find = action.getdatatype.filter((itemRow) => updateditem.dataType === itemRow.id)
        if (filter_find.length > 0) {
          updateditem.dataType = filter_find[0].name
        } else {
          updateditem.dataType = ""
        }
        return updateditem
      })
      return {
        ...state,
        data: updatedcoloumn,
        totalcount: action.payload.data.total_count,
        rowsPerPage: action.rowsPerPage,
        page: action.page,
        order: action.order,
        orderBy: action.orderBy,
        islogin: true,
        norecord: action.payload.data.result.length === 0,
      }
    case CUSTOM_FIELD_SERVICE_FAIL:
      return { ...state, error: action.payload, data: [], loading: false, totalcount: 0, search_text: action.search_text }
    case CUSTOM_FIELD_SERVICE_CLEAR:
      return { ...INITIAL_STATE }
    case CUSTOM_FIELD_LOCAL_SEARCH:
      return { ...state, search_text: action.search_text }
    case CUSTOM_FIELD_SERVICE_INSERTED:
      const inserteditem = {}
      inserteditem.code = action.insert_code
      if (action.payload.labelName.includes("__dot__")) {
        inserteditem.labelName = action.payload.labelName.replace(/__dot__/g, ".")
      } else {
        inserteditem.labelName = action.payload.labelName
      }
      inserteditem.dataType = getdropdownvalue({ formValues: action.payload, field: "dataType", prop: "name" })
      return { ...state, data: [inserteditem, ...state.data] }

    case CUSTOM_FIELD_SERVICE_DELETED:
      return deleteInReducer({ action, state, key: "data" })
    case CUSTOM_FIELD_SERVICE_UPDATED:
      let updateddata = state.data.map((item, index) => {
        if (convertIntif(item.code) !== convertIntif(action.payload.update_code)) {
          return item
        }
        const updateditem = { ...item }
        if (action.payload.labelName.includes("__dot__")) {
          updateditem.labelName = action.payload.labelName.replace(/__dot__/g, ".")
        } else {
          updateditem.labelName = action.payload.labelName
        }
        updateditem.dataType = getdropdownvalue({ formValues: action.payload, field: "dataType", prop: "name" })
        return updateditem
      })

      return { ...state, data: updateddata }
    default:
      return state
  }
}
